<template>
  <div class="device-type-container">
    <el-card shadow="never">
      <div class="card-header">
        <h2>设备类型</h2>
        <el-button type="primary" @click="dialogVisible = true">
          <i class="el-icon-plus"></i> 新增设备类型
        </el-button>
      </div>
      
      <el-table :data="deviceTypes" stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod"></el-table-column>
        <el-table-column prop="name" label="类型名称" width="200"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column prop="enabled" label="状态" width="120">
          <template slot-scope="scope">
            <el-switch 
              v-model="scope.row.enabled" 
              active-color="#13ce66" 
              inactive-color="#ff4949"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="200">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="editDeviceType(scope.row)">
              编辑
            </el-button>
            <el-button type="danger" size="small" @click="deleteDeviceType(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 新增/编辑设备类型对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入设备类型名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入设备类型描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeviceType',
  data() {
    return {
      deviceTypes: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      dialogTitle: '新增设备类型',
      form: {
        id: null,
        name: '',
        description: '',
        enabled: true
      },
      rules: {
        name: [
          { required: true, message: '请输入设备类型名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getDeviceTypes()
  },
  methods: {
    getDeviceTypes() {
      this.$http.get('/api/device-types')
        .then(response => {
          this.deviceTypes = response.data
          this.total = response.data.length
        })
        .catch(error => {
          this.$message.error('获取设备类型列表失败')
          console.error('Error:', error)
        })
    },
    
    editDeviceType(row) {
      this.dialogTitle = '编辑设备类型'
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },
    
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            // 更新设备类型
            this.$http.put(`/api/device-types/${this.form.id}`, this.form)
              .then(() => {
                this.$message.success('设备类型更新成功')
                this.dialogVisible = false
                this.getDeviceTypes()
                this.resetForm()
              })
              .catch(error => {
                this.$message.error('设备类型更新失败')
                console.error('Error:', error)
              })
          } else {
            // 新增设备类型
            this.$http.post('/api/device-types', this.form)
              .then(() => {
                this.$message.success('设备类型新增成功')
                this.dialogVisible = false
                this.getDeviceTypes()
                this.resetForm()
              })
              .catch(error => {
                this.$message.error('设备类型新增失败')
                console.error('Error:', error)
              })
          }
        } else {
          return false
        }
      })
    },
    
    resetForm() {
      this.form = {
        id: null,
        name: '',
        description: '',
        enabled: true
      }
    },
    
    deleteDeviceType(id) {
      this.$confirm('确定要删除该设备类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/api/device-types/${id}`)
          .then(() => {
            this.$message.success('设备类型删除成功')
            this.getDeviceTypes()
          })
          .catch(error => {
            this.$message.error('设备类型删除失败')
            console.error('Error:', error)
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    handleStatusChange(row) {
      this.$http.put(`/api/device-types/${row.id}`, row)
        .then(() => {
          this.$message.success('状态更新成功')
        })
        .catch(error => {
          this.$message.error('状态更新失败')
          console.error('Error:', error)
          // 恢复原来的状态
          row.enabled = !row.enabled
        })
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      this.getDeviceTypes()
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDeviceTypes()
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    indexMethod(index) {
      // 计算当前行在整个数据集中的序号
      return (this.currentPage - 1) * this.pageSize + index + 1
    }
  }
}
</script>

<style scoped>
.device-type-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>